import { ContentType, HttpClient, RequestParams } from '../http-client';

export class CompanyLearning<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getCompanyLearningCourses = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/courses`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addCompanyLearningCourse = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/courses`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningCourseById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/courses/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyLearningCourseById = (
    id: string,
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/courses/${id}`,
      method: 'PATCH',
      body: payload,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathList = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addCompanyLearningPath = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyLearningPathById = (
    id: number,
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/${id}`,
      method: 'PATCH',
      body: payload,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathAvailableCourses = (id, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/${id}/courses/available`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addCompanyLearningCourseToPath = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/course`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  deleteCompanyLearningCourseInPathById = (
    id: number,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/course/${id}`,
      method: 'DELETE',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  publishCompanyLearningPath = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/published`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathById = (id: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/${id}/published`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathByIdReport = (id: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/published/${id}/report`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathPublishedEnrollment = (query: {
    page: number;
    full_name?: string;
    rank?: string;
    publish_id?: number;
    learning_path_id?: number;
  }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/published/enrollment`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathEnrollmentById = (id: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/published/enrollment/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyLearningPathEnrollmentSectionById = (
    id: number,
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/published/enrollment/section/${id}`,
      method: 'PATCH',
      body: payload,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyFeedbackByPublishId = (query: {
    publish_id?: number;
    status?: string;
  }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/feedbacks`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathReport = (query: {
    search?: string;
    vessel_id?: number[];
    learning_path_id?: number[];
    rank?: string[];
    status?: string[];
    page?: number;
    is_archived?: boolean;
  }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/report`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningMatrix = (query: {
    type?: string;
    vessel_id?: number;
    excel?: boolean;
  }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/matrix`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyLearningPathReportParams = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/path/report/params`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  resetCompanyLearningCourseChapter = (
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/learning/course/chapter/reset`,
      method: 'PATCH',
      body: payload,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
